export default "__VITE_ASSET__DUyLBj8A__"